module.exports = __webpack_public_path__ + "static/img/icon55.59ba1d7f.png";